<div class="landingscroll">
  <div *ngIf="bannerDetails && bannerDetails.length > 0" style="margin-top: 18px;">
    <div class="banner" *ngFor="let item of bannerDetails" [innerHTML]="item.htmlText" [ngStyle]="{'background-color':item.backgroundColor,'color':item.textColor,}">
    </div>
  </div>
  <div class="landingcontainer">
    <div style="position: relative" [ngStyle]="{'margin-top':bannerString!=''?'40px':'60px'}" >
      <div>
        <img
          src="assets/images/homePageImg.png"
          height="270px"
          width="390px"
          class="landingimg"
          alt="Image of Meeting of Diversified People"
        />
      </div>
    </div>
    <div class="landingSection">
      <div [ngStyle]="{'margin-top':bannerString!=''?'50px':'70px'}">
        <h1 class="landingpara">Welcome to the ODP Performance-Based <br> Contracting Data Submission Portal</h1>
      </div>
      <div class="landinguser">
        <span>Hello, {{userName}}!</span>
        <p class="landinginfo">Enter and upload your agency’s PBC data with ease. This tool offers an intuitive interface and guided forms so your team can work together, save progress, and make updates . Access your agency’s PBC profile, track submission status in real time, and manage all your PBC-related information in one secure place.</p>
        <p class="landinginfo">
          To get started, select the <b>"Access My PBC Profile"</b> button below.
        </p>
        <p class="landinginfo">
          Need assistance? Check out the <a [routerLink]="'/help'">Help</a> or <a [routerLink]="'/contact'">Contact Us</a> screens.
        </p>
      </div>
    </div>
  </div>
  <hr style="margin-left:5%;margin-right: 5%;">
  <div class="cardcontainer">
    <div class="custom-card">
      <div class="custom-card-img">
        <img src="assets/images/scoCardImg.png" alt="SCO" />
      </div>
      <div class="custom-card-body">
        <h2 class="custom-card-title"> Submission Center</h2>
        <p class="custom-card-desc">Submit your information, upload files, and track your agency's progress—all in one place.</p>
        <p class="custom-card-desc">Submissions will be reviewed , and you will be notified of the results or if additional information is required.</p>
      </div>
      <div class="cardButton">
        <!-- <button class="accessbtn" [routerLink]="'/businessProcess'" >Start a New Form</button> -->
        <button class="accessbtn" [routerLink]="'/businessProcess'">Access My PBC Profile</button>
      </div>
    </div>

    <!-- <div class="custom-card">
      <div class="custom-card-img">
        <img src="assets/images/rhoImg.jpeg" alt="SCO" />
      </div>
      <div class="custom-card-body">
        <p class="custom-card-title">RH Provider PBC</p>
        <p class="custom-card-desc">Add Description</p>
        <button class="accessbtn">Access Select Tier Form</button>
      </div>
    </div> -->
  </div>
</div>